import React, { createContext, useState } from "react";

const TipoServicoContext = createContext();

const TipoServicoContextProvider = ({ children }) => {
  const defaultVerification = { label: "Data Emissão", value: "Emissão" };
  const defaultPeriod = { label: "Dia", value: "Dia" };

  const [loading, setLoading] = useState(false);

  /**
   * Principal
   */
  const [errorsSubmit, setErrorsSubmit] = useState({});
  const [active, setActive] = useState(true);
  const [description, setDescription] = useState("");
  const [serviceCityCode, setServiceCityCode] = useState("");
  const [cnae, setCnae] = useState("");
  const [codeNfse, setCodeNfse] = useState("");
  const [codeIbpt, setCodeIbpt] = useState("");
  const [descriptionIbpt, setDescriptionIbpt] = useState("");
  const [companies, setCompanies] = useState([]);
  const [serviceId, setServiceId] = useState(null);
  const [contractSelected, setContractSelected] = useState(null);
  const [contractList, setContractList] = useState([]);
  const [selectedNbs, setSelectedNbs] = useState(null);

  /**
   * Tributação
   */

  const [listVerification] = useState([
    { label: "Data Emissão", value: "Emissão" },
    { label: "Data Vencimento", value: "Vencimento" },
  ]);
  const [listPeriod] = useState([
    { label: "Dia", value: "Dia" },
    { label: "Mês", value: "Mês" },
  ]);
  const [listIbpt, setListIbpt] = useState([]);
  const [listUf, setListUf] = useState([]);
  const [listCities, setListCities] = useState([]);
  const [listCitiesByUf, setListCitiesByUf] = useState([]);

  const [pis, setPis] = useState("0,00");
  const [cofins, setCofins] = useState("0,00");
  const [csll, setCsll] = useState("0,00");
  const [irrf, setIrrf] = useState("0,00");
  const [inss, setInss] = useState("0,00");
  const [iss, setIss] = useState("0,00");
  const [redBcIss, setRedBcIss] = useState("0,00");
  const [issRet, setIssRet] = useState(false);
  const [withheldPisCofinsCsll, setWithhedlPisCofinsCsll] = useState(false);
  const [withheldIrrf, setWithheldIrrf] = useState(false);
  const [withheldInss, setWithheldInss] = useState(false);
  const [
    verificationPisCofinsCsllMinValue,
    setVerificationPisCofinsCsllMinValue,
  ] = useState("0,00");
  const [verificationIrffMinValue, setVerificationIrffMinValue] =
    useState("0,00");
  const [verificationInssMinValue, setVerificationInssMinValue] =
    useState("0,00");

  const [verificationPisCofinsCsll, setVerificationPisCofinsCsll] =
    useState(defaultVerification);
  const [verificationIrff, setVerificationIrff] = useState(defaultVerification);
  const [verificationInss, setVerificationInss] = useState(defaultVerification);

  const [periodPisCofinsCsll, setPeriodPisCofinsCsll] = useState(defaultPeriod);
  const [periodIrrf, setPeriodIrrf] = useState(defaultPeriod);
  const [periodInss, setPeriodIndss] = useState(defaultPeriod);

  const [uf, setUf] = useState(null);
  const [city, setCity] = useState(null);
  const [aliqRet, setAliqRet] = useState("0,00");
  const [reduction, setReduction] = useState("0,00");
  const [withheldSn, setWithheldSn] = useState(false);

  const [tableWithholdings, setTableWithholdings] = useState([]);
  const [withholdingsErrors, setWithholdingsErrors] = useState({});
  const [editwithholdingsErrors, setEditWithholdingsErrors] = useState({});

  const [additionalData, setAdditionalData] = useState("");

  const [taxationList] = useState([
    { value: "None", description: "Nenhuma" },
    { value: "WithinCity", description: "Dentro da Cidade" },
    { value: "OutsideCity", description: "Fora da Cidade" },
    { value: "Export", description: "Exportação" },
    { value: "Free", description: "Isento" },
    { value: "Immune", description: "Imune" },
    {
      value: "SuspendedCourtDecision",
      description: "Suspenso por decisão judicial",
    },
    {
      value: "SuspendedAdministrativeProcedure",
      description: "Suspenso por procedimento administrativo",
    },
    { value: "OutsideCityFree", description: "Fora da cidade - Isento" },
    { value: "OutsideCityImmune", description: "Fora da cidade - Imune" },
    { value: "OutsideCitySuspended", description: "Fora da cidade - Suspenso" },
    {
      value: "OutsideCitySuspendedAdministrativeProcedure",
      description: "Fora da cidade - Suspenso por procedimento administrativo",
    },
  ]);

  const [taxation, setTaxation] = useState({
    value: "None",
    description: "Nenhuma",
  });

  return (
    <TipoServicoContext.Provider
      value={{
        active,
        setActive,
        description,
        setDescription,
        serviceCityCode,
        setServiceCityCode,
        cnae,
        setCnae,
        pis,
        setPis,
        cofins,
        setCofins,
        csll,
        setCsll,
        irrf,
        setIrrf,
        inss,
        setInss,
        iss,
        setIss,
        redBcIss,
        setRedBcIss,
        issRet,
        setIssRet,
        uf,
        setUf,
        city,
        setCity,
        aliqRet,
        setAliqRet,
        reduction,
        setReduction,
        tableWithholdings,
        setTableWithholdings,
        withholdingsErrors,
        setWithholdingsErrors,
        verificationPisCofinsCsllMinValue,
        setVerificationPisCofinsCsllMinValue,
        verificationIrffMinValue,
        setVerificationIrffMinValue,
        verificationInssMinValue,
        setVerificationInssMinValue,
        listVerification,
        verificationPisCofinsCsll,
        setVerificationPisCofinsCsll,
        verificationIrff,
        setVerificationIrff,
        verificationInss,
        setVerificationInss,
        listPeriod,
        periodPisCofinsCsll,
        setPeriodPisCofinsCsll,
        periodIrrf,
        setPeriodIrrf,
        periodInss,
        setPeriodIndss,
        errorsSubmit,
        setErrorsSubmit,
        codeNfse,
        setCodeNfse,
        codeIbpt,
        setCodeIbpt,
        loading,
        setLoading,
        listIbpt,
        setListIbpt,
        listUf,
        setListUf,
        listCities,
        setListCities,
        listCitiesByUf,
        setListCitiesByUf,
        editwithholdingsErrors,
        setEditWithholdingsErrors,
        descriptionIbpt,
        setDescriptionIbpt,
        companies,
        setCompanies,
        serviceId,
        setServiceId,
        withheldPisCofinsCsll,
        setWithhedlPisCofinsCsll,
        withheldIrrf,
        setWithheldIrrf,
        withheldInss,
        setWithheldInss,
        withheldSn,
        setWithheldSn,
        additionalData,
        setAdditionalData,
        contractSelected,
        setContractSelected,
        contractList,
        setContractList,
        taxationList,
        taxation,
        setTaxation,
        selectedNbs,
        setSelectedNbs,
      }}
    >
      {children}
    </TipoServicoContext.Provider>
  );
};

export { TipoServicoContextProvider, TipoServicoContext };
